import React, { useState, useMemo, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Tippy from '@tippyjs/react';
import { setEnableClosedSidebar } from "../../reducers/ThemeOptions";
import { Link } from 'react-router-dom';
import HomeItemNavItem from "./CustomNavItems/HomeItemNavItem";
import { ReactComponent as DownArrow } from "../../../src/assets/utils/images/svgs/downArrow.svg";
import { ReactComponent as RightArrow } from "../../../src/assets/utils/images/svgs/sideArrow.svg";
import { ReactComponent as SmsIcon } from "../../assets/utils/images/svgs/sms.svg";
import { ReactComponent as FeatureIcon } from "../../assets/utils/images/svgs/db-gray.svg";
import { ReactComponent as CostIcon } from "../../assets/utils/images/svgs/cost-icon.svg";
import { ReactComponent as CalendarIcon } from "../../assets/utils/images/svgs/calendar-gray-stroke.svg";
import { ReactComponent as SendSMSIcon } from "../../assets/utils/images/svgs/send-sms.svg";
import { ReactComponent as ReplacementIcon } from "../../assets/utils/images/svgs/replacement-icon.svg";
import { ReactComponent as SchoolIcon } from "../../assets/utils/images/svgs/school.svg";
import { ReactComponent as Contracttypen } from "../../assets/utils/images/svgs/Contracttypen.svg";
import { ReactComponent as BesturenIcon } from "../../assets/utils/images/svgs/BesturenIcon.svg";
import { ReactComponent as PlanningIcon } from "../../assets/utils/images/svgs/PlanningIcon.svg";
import { ReactComponent as BesturenSIcon } from "../../assets/utils/images/svgs/BesturenSIcon.svg";
import { ReactComponent as AnonymizeIcon } from "../../assets/utils/images/svgs/Anonymize.svg";
import { ReactComponent as DocumentGearIcon } from "../../assets/utils/images/svgs/DocumentGear.svg";
import { ReactComponent as SupportDoc } from "../../assets/utils/images/svgs/SupportDoc.svg";
import { ReactComponent as AfasSoftware } from "../../assets/utils/images/svgs/AfasSoftware.svg";
import { ReactComponent as LogboekLogin } from "../../assets/utils/images/svgs/LogboekLogin.svg";
import { ReactComponent as BurgerIcon } from '../../assets/utils/images/svgs/SidebarToggle.svg';
import FeedbackNavItem from './CustomNavItems/FeedbackNavItem';
import WeekReportActueelNavItem from './CustomNavItems/WeekReportActueelNavItem';
import { useNavBlock } from 'helperFunctions/GuardNavigation';
import AuthService from 'Api/Auth';
import { flexRender } from '@tanstack/react-table';


const iconStyle = {
  fontSize: 20,
  display: "flex",
  alignItems: "center",
};

const renderMenuIcon = (icon, className = '') => {
  if (React.isValidElement(icon)) {
    return (
      <span className={`icon-container ${className}`.trim()} >
        {icon}
      </span>
    );
  }

  if (!icon) {
    return null;
  }

  return <i className={`metismenu-icon ${icon} sidebar-icon-size ${className}`.trim()} />
};

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { guardedNavigate } = useNavBlock();
  const userRoles = useSelector((state) => state.UserPermission);
  const enableClosedSidebar = useSelector((state) => state.ThemeOptions.enableClosedSidebar);
  const dispatch = useDispatch();

  const [openSubmenuKeys, setOpenSubmenuKeys] = useState({});
  const [active, setActive] = useState(false);

  
const toggleEnableClosedSidebar = () => {
  if (window.innerWidth < 1250) {
    // Keep sidebar collapsed on mobile and iPad
    dispatch(setEnableClosedSidebar(true));
    setActive(false);
    return;
  }

  // Normal toggle on desktop
  dispatch(setEnableClosedSidebar(!enableClosedSidebar));
  setActive(!active);
};

  const [openItemKeys, setOpenItemKeys] = useState({});
  const [activeItem, setActiveItem] = useState({
    role: '',
    parentLabel: '',
    childLabel: '',
  });

  useEffect(() => {
    setOpenSubmenuKeys({});
  }, [userRoles]);

  useEffect(() => {
    updateActiveItem(location.pathname);
  }, [location.pathname, userRoles.roles]);

  const toggleItem = (key) => {
    setOpenItemKeys(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const updateActiveItem = (pathname) => {
    let activeRole = '';
    let activeParentLabel = '';
    let activeChildLabel = '';

    const preferredRole = userRoles.roles.includes("administrator")
      ? "administrator"
      : userRoles.roles.includes("coordinator")
        ? "coordinator"
        : userRoles.roles.includes("requestor")
          ? "requestor"
          : userRoles.roles[0];

    for (const role of sidebarLinks) {
      // if (role.permission !== preferredRole) continue;
      if (!userRoles.roles.includes(role.permission)) continue;
      for (const [subIndex, submenu] of role.submenu.entries()) {
        let parentIsActive = false;

        //Check if this parent is active 
        if (submenu.activePaths?.length > 0) {
          parentIsActive = submenu.activePaths.some(
            (p) => pathname === p || pathname.startsWith(p + '/')
          );
        } else if (submenu.path) {
          parentIsActive =
            pathname === submenu.path ||
            pathname.startsWith(submenu.path + '/') ||
            (submenu.items?.some((item) =>
              pathname === item.path || pathname.startsWith(item.path + '/')
            ) ?? false);
        }

        if (!parentIsActive) continue;
        activeRole = role.permission;
        activeParentLabel = submenu.label;
        if (submenu.items?.length > 0) {
          for (const item of submenu.items) {
            let childIsActive = false;

            if (item.activePaths?.length > 0) {
              childIsActive = item.activePaths.some(
                (p) => pathname === p || pathname.startsWith(p + '/')
              );
            } else if (item.path) {
              childIsActive =
                pathname === item.path || pathname.startsWith(item.path + '/');
            }

            if (childIsActive) {
              activeChildLabel = item.label;
              setActiveItem({ role: activeRole, parentLabel: activeParentLabel, childLabel: activeChildLabel });
              return;
            }
          }
        }
        setActiveItem({ role: activeRole, parentLabel: activeParentLabel, childLabel: '' });
        return;
      }
    }
    setActiveItem({ role: '', parentLabel: '', childLabel: '' });
  };

  const isParentActive = (role, parentLabel) => {
    if (activeItem?.childLabel) {
    }
    return activeItem.role === role && activeItem.parentLabel === parentLabel;
  }

  const isParentHighlighted = (role, parentLabel) =>
    isParentActive(role, parentLabel) && !activeItem.childLabel;

  const isChildActive = (role, parentLabel, childLabel) =>
    isParentActive(role, parentLabel) && activeItem.childLabel === childLabel;

  const getSubmenuKey = (rolePermission, subIndex) => `${rolePermission}-${subIndex}`;
  const toggleSubmenu = (rolePermission, subIndex, hasItems) => {
    if (enableClosedSidebar || !hasItems) return;

    const key = getSubmenuKey(rolePermission, subIndex);

    setOpenSubmenuKeys((prev) => {
      const newState = { ...prev };
      Object.keys(newState).forEach((existingKey) => {
        if (existingKey.startsWith(`${rolePermission}-${subIndex}`) && isSubmenuOpen(rolePermission, subIndex)) {
          delete newState[existingKey];
        }
      });


      if (!prev[key] && !isSubmenuOpen(rolePermission, subIndex)) {
        newState[key] = true;
      }
      return newState;
    });
  };

  const isSubmenuOpen = (rolePermission, subIndex) =>
    !!openSubmenuKeys[getSubmenuKey(rolePermission, subIndex)];

  const sidebarLinks = useMemo(() => {
    return [
      {
        permission: 'coordinator',
        label: 'Coordinator',
        submenu: [
          {
            label: 'Verzoeken',
            path: '/verzoeken/overzicht',
            icon: 'pe-7s-home',
            activePaths: [
              '/verzoeken/overzicht',
              '/verzoeken/overzicht/:id',
              '/verzoeken/overzicht/:id/dagdelen-toevoegen',
              '/verzoeken/planscreen',   
              '/verzoeken/planscreen/:id/:dayId',
              '/verzoeken/vervanger-zoeken',
              '/verzoeken/vervanger-zoeken/:subsId/:dayId',
              '/verzoeken/planbord',
              '/verzoeken/indienen',
              '/verzoeken/:id',
            ],
            items: [
              {
                label: 'Planbord',
                path: '/verzoeken/planbord',
                activePaths: ['/verzoeken/planbord',
                  '/verzoeken/planbord/:id'],
                icon: 'pe-7s-target',
              },
              {
                label: 'Indienen verzoek',
                path: '/verzoeken/indienen',
                activePaths: ['/verzoeken/indienen', '/verzoeken/indienen/nieuwe'],
                icon: 'pe-7s-magic-wand',
              },
            ],
          },
           {
            label: 'Gebruikers', path: '/gebruikers',
            activePaths: [
              '/gebruikers',
              '/gebruikers/:gebruikerId',
            ],
            icon: 'pe-7s-users'
          },
           {
            label: 'Weekstaten',
            path: '/weekstaten/overzicht',
            icon: 'pe-7s-note2',
            activePaths: [
              '/weekstaten',
              '/weekstaten/overzicht',
              '/weekstaten/:id',
              '/weekstaten/samenstellen'
            ],
            items: [
              { label: 'Samenstellen', path: '/weekstaten/samenstellen', icon: 'pe-7s-right-arrow' },
            ],
          },
          {
            label: 'Reiskosten',
            path: '/reiskosten/overzicht',
            icon: 'pe-7s-bicycle',
            activePaths: [
              '/reiskosten',
              '/reiskosten/overzicht',
              '/reiskosten/afstanden',
              '/reiskosten/samenstellen',
            ],
            items: [
              { label: 'Afstanden', path: '/reiskosten/afstanden', icon: 'pe-7s-map-2' },
              { label: 'Samenstellen', path: '/reiskosten/samenstellen', icon: 'pe-7s-right-arrow' },
            ],
          },
         
          { label: 'Rapportage', path: '/rapportage', icon: 'pe-7s-graph2' },
        

          {
            label: 'Overig',
            path: '/overig/sms-versturen',
            icon: 'pe-7s-plugin',
            activePaths: [
              '/overig/sms-versturen',
              '/overig/exporteren',
              '/overig/documentenbeheer',
              '/overig/Login',
              '/overig/Persoonsgegevens',
              '/overig/Inzage',
              '/overig/Authorisatie',
              '/links/coordinator'
            ],
            items: [
              { label: 'Sms-Versturen', path: '/overig/sms-versturen', icon: <SendSMSIcon /> },
              { label: 'Exporteren', path: '/overig/exporteren', icon: <SendSMSIcon /> },
              { label: 'Documentenbeheer', path: '/overig/documentenbeheer', icon: <DocumentGearIcon /> },
              { label: 'Persoonsgegevens', path: '/overig/Persoonsgegevens', icon: <LogboekLogin /> },
              { label: 'Inzage', path: '/overig/Inzage', icon: <LogboekLogin /> },
              { label: 'Authorisatie', path: '/overig/Authorisatie', icon: <LogboekLogin /> },
              { label: 'Externe Links', path: '/links/coordinator', icon: 'pe-7s-link' },
            ],
          },
          
          {
            label: 'Instellingen',
            path: '/c-instellingen/besturen',
            icon: 'pe-7s-config',
            activePaths: [

              '/c-instellingen/Besturen',
              '/c-instellingen/functies',
              '/c-instellingen/dagtypen',
              '/c-instellingen/vervangingscodes',
              '/c-instellingen/Kp-Kd',
              '/c-instellingen/scholen',
              '/c-instellingen/scholen/:communityId/:schoolId',
              '/c-instellingen/contracttypen',
              '/c-instellingen/contracttypen/wijzigen-toevoegen/:id',
              '/c-instellingen/contracttypen/filterinstellingen/:id',
              '/c-instellingen/besturen',
              '/c-instellingen/planning',
            ],
            items: [
              { label: 'Besturen', path: '/c-instellingen/besturen', icon: <BesturenIcon /> },
              { label: 'Functies', path: '/c-instellingen/functies', icon: <FeatureIcon /> },
              { label: 'Dagtypen', path: '/c-instellingen/dagtypen', icon: <CalendarIcon /> },
              { label: 'Kp/Kd', path: '/c-instellingen/Kp-Kd', icon: <CostIcon /> },
              { label: 'Vervangingscodes', path: '/c-instellingen/vervangingscodes', icon: <ReplacementIcon /> },
              { label: 'Scholen', path: '/c-instellingen/scholen', icon: <SchoolIcon /> },
              { label: 'Contracttypen', path: '/c-instellingen/contracttypen', icon: <Contracttypen /> },
              { label: 'Planning', path: '/c-instellingen/planning', icon: <PlanningIcon /> },
            ],
          },
        ],
      },
      {
        permission: AuthService.AFAS_ROLE,
        label: 'Salaris',
        submenu: [
          {
            label: 'Afas',
            path: '/afas/openstaand',
            icon: <AfasSoftware />,
            activePaths: [
              '/afas',
              '/afas/openstaand',
              '/afas/synchronisatie',
              '/afas/historie',
              '/afas/conflicten',
            ],
          },
        ],
      },
      {
        permission: 'requestor',
        label: 'Melder',
        submenu: [
          {
            label: 'Verzoeken',
            path: '/verzoeken',
            icon: 'pe-7s-home',
            activePaths: [
              '/verzoeken',
              '/verzoeken/historie',
              // '/verzoeken/:id',
              '/verzoeken/:id/dagdelen-toevoegen',

            ],
            items: [
              { label: 'Historie', path: '/verzoeken/historie', icon: 'pe-7s-server' },
            ],
          },
          {
            label: 'Indienen',
            path: '/indienen',
            icon: 'pe-7s-magic-wand',
          },
          {
            label: <WeekReportActueelNavItem />,
            path: '/weekstaat/actueel',
            icon: 'pe-7s-note2',
            activePaths: [
              '/weekstaat/:id',
              '/weekstaat/actueel',
              '/weekstaat/historie',
            ],
            items: [
              { label: 'Historie', path: '/weekstaat/historie', icon: 'pe-7s-server' },
            ],
          },

          {
            label: 'Documenten',
            path: '/documenten',
            icon: 'pe-7s-id',
          },
          {
            label: <FeedbackNavItem />,
            path: '/terugkoppeling',
            icon: (
              <i className="metismenu-icon pe-7s-loop sidebar-icon-size" />
            ),
          },
          {
            label: 'Export',
            path: '/export',
            icon: 'pe-7s-download',
          },
          {
            label: 'Externe Links',
            path: '/links/requestor',
            icon: 'pe-7s-link',
          },
        ],
      },
      {
        permission: 'substitutor',
        label: 'Vervanger',
        submenu: [
          {
            label: <HomeItemNavItem />,
            path: '/home',
            icon: 'pe-7s-home',
          },
          {
            label: 'Beschikbaarheid',
            path: '/beschikbaarheid',
            icon: 'pe-7s-date',
          },
          {
            label: 'Reiskosten',
            path: '/v-reiskosten',
            icon: 'pe-7s-bicycle',
          },
          {
            label: 'Documenten',
            path: '/v-documenten',
            icon: 'pe-7s-id',
          },
          {
            label: 'Urenoverzicht',
            path: '/urenoverzicht',
            icon: 'pe-7s-graph3',
          },
          {
            label: 'Instellingen',
            path: '/instellingen',
            icon: 'pe-7s-config',
          },
          {
            label: 'Externe Links',
            path: '/links/substitutor',
            icon: 'pe-7s-link',
          },
        ],
      },
      {
        permission: "administrator",
        label: "Beheer",
        submenu: [
          {
            label: "Gebruikers",
            path: "/beheerder/gebruikers",
            icon: "pe-7s-users",
          },
          {
            label: "Instellingen",
            path: "/beheerder/instellingen",
            icon: "pe-7s-config",
          },
          {
            label: "Externe Links",
            path: "/beheerder/links",
            icon: "pe-7s-link",
          },
          {
            label: "PowerBI Api",
            path: "/beheerder/api",
            icon: "pe-7s-way",
          },
          {
            label: "Besturen",
            path: "/beheerder/besturen",
            icon: <BesturenSIcon />,
          },
          {
            label: "Functies",
            path: "/beheerder/functies",
            icon: "pe-7s-users",
          },
          {
            label: "SMS statistieken",
            path: "/beheerder/admin-sms",
            icon: <SmsIcon />,
          },
          // {
          //   label: "Log Login",
          //   path: "/beheerder/logging",
          //   icon: "pe-7s-display2",
          // },

          {
            label: "Logging",
            path: "/beheerder/logging/Login",
            icon: "pe-7s-display2",
            activePaths: [
              "/beheerder/logging/Login",
              "/beheerder/logging/Persoonsgegevens",
              "/beheerder/logging/Inzage",
              "/beheerder/logging/Authorisatie",
              "/beheerder/logging/push-messages",
            ],
            items: [
              {
                label: "Login",
                path: "/beheerder/logging/Login",
                icon: <LogboekLogin />,
              },
              {
                label: "Persoonsgegevens",
                path: "/beheerder/logging/Persoonsgegevens",
                icon: <LogboekLogin color="#878EA6" />,
              },
              {
                label: "Inzage",
                path: "/beheerder/logging/Inzage",
                icon: <LogboekLogin color="#878EA6" />,
              },
              {
                label: "Authorisatie",
                path: "/beheerder/logging/Authorisatie",
                icon: <LogboekLogin color="#878EA6" />,
              },
              {
                label: "Push-Messages",
                path: "/beheerder/logging/push-messages",
                icon: "pe-7s-users",
              },
            ],
          },
          {
            label: "Rollen",
            path: "/beheerder/rollen",
            icon: "pe-7s-users",
          },
          {
            label: "Anonimiseren",
            path: "/beheerder/anonimiseren",
            icon: <AnonymizeIcon />,
          },

          {
            label: "Theme",
            path: "/beheerder/theme",
            icon: <AnonymizeIcon />,
          },
        ],
      },
      {
        permission: 'documentbeheer',
        label: 'documentbeheer',
        submenu: [
          {
            label: 'Docs Goedkeuren',
            path: '/documentbeheer',
            icon: <SupportDoc />,
          },
        ],
      },
      {
        permission: 'support',
        label: 'Support',
        submenu: [
          {
            label: 'Support',
            path: '/support/gebruikers',
            icon: 'pe-7s-help1',
            items: [
              { label: 'Gebruikers', path: '/support/gebruikers', icon: 'pe-7s-users' },
            ],
          },
        ],
      },
    ];
  }, []);

  const filteredSidebarLinks = useMemo(() => {
    if (userRoles.roles.includes('administrator')) {
      return sidebarLinks.filter(role => role.permission === 'administrator');
    }

    return sidebarLinks.filter((role) => userRoles.roles.includes(role.permission));
  }, [userRoles, sidebarLinks]);

  useEffect(() => {
    if (!location.pathname || !userRoles.roles?.length) return;

    for (const role of sidebarLinks) {
      if (!userRoles.roles.includes(role.permission)) continue;

      const submenuIndex = role.submenu?.findIndex((submenu) => {
        if (submenu.activePaths?.length) {
          return submenu.activePaths.some(
            (path) =>
              location.pathname === path ||
              location.pathname.startsWith(path + '/')
          );
        }

        if (submenu.path) {
          return (
            location.pathname === submenu.path ||
            location.pathname.startsWith(submenu.path + '/') ||
            submenu.items?.some(
              (item) =>
                location.pathname === item.path ||
                location.pathname.startsWith(item.path + '/')
            )
          );
        }

        return false;
      });

      if (submenuIndex !== -1 && submenuIndex !== undefined) {
        const key = getSubmenuKey(role.permission, submenuIndex);

        setOpenSubmenuKeys({
          [key]: true,
        });

        return;
      }
    }

    setOpenSubmenuKeys({});
  }, [location.pathname, userRoles.roles, sidebarLinks]);


  return (
    <aside
      className={`fixed top-0 left-0 h-screen border-r border-gray-200 transition-all duration-300 z-30 ${enableClosedSidebar ? 'w-16' : 'w-64'
        }`}
    >

      <nav className={`${enableClosedSidebar ? 'p-1' : 'p-0'}`}>
        {enableClosedSidebar && (
          <div
            className="sidebar-collapsed-burger"
            onClick={toggleEnableClosedSidebar}
          >
            <BurgerIcon className="burger-svg" />

          </div>
        )}
        <ul className="list-unstyled sidebar-container">

          {filteredSidebarLinks.map((role, index) => (
            <React.Fragment key={index}>
              {role.label && (
                <h2
                  className={`app-sidebar__heading sidebar-roles ${enableClosedSidebar
                    ? 'collapsed-heading'
                    : 'expanded-heading'
                    }`}
                >
                  <div className={`d-flex justify-content-between gap-2 flex-column ${enableClosedSidebar ? '' : 'sidebar-role-label'
                    }`}>
                    <div className={enableClosedSidebar ? '' : 'sidebar-role-label'}>

                      {!enableClosedSidebar && (
                        <div className='d-flex'>

                          <span className='sidebar-icon'>

                            <BurgerIcon className="burger-svg" onClick={index === 0 ? toggleEnableClosedSidebar : undefined}
                              style={{
                                cursor: index === 0 ? 'pointer' : 'default'
                              }} />
                          </span>


                        </div>
                      )}
                      <span className="sidebar-label">
                        {role.label}
                      </span>
                    </div>
                  </div>

                </h2>
              )}

              {role.submenu?.map((submenu, subIndex) => {
                const hasSubItems = submenu.items && submenu.items.length > 0;
                const isActiveParent = isParentActive(role.permission, submenu.label);
                const isHighlightedParent = isParentHighlighted(role.permission, submenu.label);

                return (
                  <li key={subIndex} style={{ position: 'relative' }} >
                    {enableClosedSidebar ? (
                      <div
                        className={`p-0 ${isActiveParent
                          ? 'sidebar-collapsed-active'
                          : 'sidebar-collapsed-inactive'
                          }`}
                        onClick={() => guardedNavigate(submenu.path)}
                      >
                        {hasSubItems ? (
                          <Tippy
                            className="no‑padding‑tippy "
                            interactive={true}
                            trigger="mouseenter"
                            placement="right"
                            arrow={false}
                            delay={100}
                            content={
                              <div className="sidebar-tippy-content">
                                {submenu.items.map((item, itemIndex) => (

                                  <Link
                                    key={itemIndex}
                                    to={item.path}
                                    className="sidebar-tippy-link menu-hover"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                    }}

                                  >

                                    {React.isValidElement(item.icon) ? (

                                      <span className="icon-container sidebarSVGs" >
                                        {item.icon}
                                      </span>
                                    ) : (

                                      <i className={`metismenu-icon ${item.icon} sidebarSVGs`} style={iconStyle} />
                                    )}
                                    <span className="sidebar-tippy-menu-text ms-2">
                                      {item.label}
                                    </span>

                                  </Link>
                                ))}
                              </div>
                            }
                          >
                            <div
                              className="sidebar-collapsed-item menu-hover"
                              onClick={() => guardedNavigate(submenu.path)}
                            >
                              {/* <div className="sidebar-collapsed-icon ms-2">
                                {renderMenuIcon(submenu.icon)}
                              </div> */}

                              <div className="sidebar-collapsed-label">
                                {submenu.label}
                              </div>
                            </div>
                          </Tippy>
                        ) : (
                          <div
                            className="sidebar-collapsed-item menu-hover"
                            onClick={() => guardedNavigate(submenu.path)}
                          >

                            <div className="sidebar-collapsed-label">
                              {submenu.label}
                            </div>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div
                        className={`d-flex justify-content-between gap-2 flex-column sidebar-menu-parent sidebar-menu-row menu-hover ${isHighlightedParent
                          ? 'sidebar-menu-active'
                          : 'sidebar-menu-inactive'
                          }`}
                        onClick={() => {
                          toggleSubmenu(role.permission, subIndex, hasSubItems);
                          guardedNavigate(submenu.path);
                        }}
                      >
                        <div className="sidebar-menu-row menu-hover">
                          <span className="sidebar-icon">
                            <span style={{ width: '21px' }}>

                              {renderMenuIcon(submenu.icon, 'sidebarSVGs')}
                            </span>
                            <span className="sidebar-label">{submenu.label}</span>
                          </span>
                          <span className="sidebar-arrow">
                            {hasSubItems ? (
                              isSubmenuOpen(role.permission, subIndex) ? (
                                <DownArrow width={15} height={15} />
                              ) : (
                                <RightArrow width={15} height={15} />
                              )
                            ) : null}
                          </span>
                        </div>
                      </div>
                    )}

                    {!enableClosedSidebar && isSubmenuOpen(role.permission, subIndex) && hasSubItems && (
                      <div className='submenu-bg'>
                        <ul className="list-unstyled sidebar-submenu-list">
                          {submenu.items.map((item, itemIndex) => {
                            const itemKey = `${role.permission}-${subIndex}-${itemIndex}`;
                            const isOpen = openItemKeys[itemKey];

                            return (
                              <li key={itemIndex}>
                                {item.items?.length > 0 ? (
                                  <>
                                    <div
                                      className={`d-flex justify-content-between align-items-center ps-5 pe-3 py-2 menu-hover sidebar-submenu-item ${isChildActive(
                                        role.permission,
                                        submenu.label,
                                        item.label
                                      )
                                        ? 'sidebar-submenu-active'
                                        : 'sidebar-submenu-inactive'
                                        }`}
                                      onClick={() => {
                                        toggleItem(itemKey);
                                        guardedNavigate(item.path);
                                      }}
                                    >
                                      <span className="d-flex align-items-center gap-1">
                                        {React.isValidElement(item.icon) ? (
                                          <span
                                            className="icon-container"
                                          >
                                            {item.icon}
                                          </span>
                                        ) : (
                                          <i className={`metismenu-icon ${item.icon} sidebar-icon-size`} />
                                        )}

                                        <span className='list-unstyled'>
                                          {item.label}
                                        </span>
                                      </span>

                                      {isOpen ? (
                                        <DownArrow width={12} height={12} />
                                      ) : (
                                        <RightArrow width={12} height={12} />
                                      )}
                                    </div>

                                    {isOpen && (
                                      <ul className="list-unstyled">
                                        {item.items.map((child, childIndex) => (
                                          <li key={childIndex}>
                                            <Link
                                              className={`d-flex align-items-center gap-1 sidebar-child-link menu-hover ${location.pathname === child.path
                                                ? 'sidebar-child-active'
                                                : 'sidebar-child-inactive'
                                                }`}
                                              to={child.path}
                                            >
                                              {React.isValidElement(child.icon) ? (
                                                <span
                                                  className="icon-container"

                                                >
                                                  {child.icon}
                                                </span>
                                              ) : child.icon ? (
                                                <i
                                                  className={`metismenu-icon ${child.icon} sidebarSVGs`}
                                                  style={iconStyle}
                                                />
                                              ) : null}
                                              <span className="list-unstyled sidebar-child-label">
                                                {child.label}
                                              </span>
                                            </Link>
                                          </li>
                                        ))}
                                      </ul>
                                    )}
                                  </>
                                ) : (
                                  <Link
                                    className={`d-flex align-items-center gap-1 ps-5 sidebar-menu-text menu-hover ${isChildActive(
                                      role.permission,
                                      submenu.label,
                                      item.label
                                    )
                                      ? 'sidebar-child-active'
                                      : 'sidebar-child-inactive'
                                      }`}
                                    to={item.path}

                                  >
                                    {React.isValidElement(item.icon) ? (
                                      <span
                                        className="icon-container"
                                        style={{ maxWidth: "140px", textOverflow: 'ellipsis' }}
                                      >
                                        {item.icon}
                                      </span>
                                    ) : (
                                      <i
                                        className={`metismenu-icon ${item.icon} sidebar-menu-text sidebarSVGs`}
                                        style={iconStyle}
                                      />
                                    )}

                                    <span className="sidebar-menu-text sidebar-menu-label">
                                      {item.label}
                                    </span>
                                  </Link>
                                )}
                              </li>
                            );
                          })}
                        </ul>
                      </div>

                    )}
                  </li>
                );
              })}
            </React.Fragment>
          ))}
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;